import './AddMeal.css'

import React, { useState, useEffect } from 'react';
import FullScreenOverlay from '../../Components/FullScreenOverlay/FullScreenOverlay';
import { IoMdClose } from "react-icons/io";
import { get, post } from '../../Services/api';
import { useAuth } from '../../Components/AuthContext/AuthContext'
import MealExplorationSlideBars from '../../Components/meal_exploration_slidebars/meal_exploration_slidebars';
import { RiGitRepositoryPrivateFill } from "react-icons/ri";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import dayjs from 'dayjs';
import CreateMealModal from '../../Components/CreateMeal/CreateMeal';
import CreateSnackModal from '../../Components/CreateSnack/CreateSnack';

function AddMeal({ modalOpen, setModalOpen, selectedMeal, selectedDate, selectedCourse, replaceUserMealId }) {
    const { currentUser } = useAuth();

    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [noResults, setNoResults] = useState(false);
    const [mealSelected, setMealSelected] = useState(null);
    const [mealSelectedDate, setMealSelectedDate] = useState(dayjs());
    const [mealSelectedCourse, setMealSelectedCourse] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check

    const [showCreateMeal, setShowCreateMeal] = useState(false);
    const [showAddMeal, setShowAddMeal] = useState(false);
    const [showAddSnack, setShowAddSnack] = useState(false);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= 768); // Update state based on window size
    };

    useEffect(() => {
        if (selectedCourse) {
            setMealSelectedCourse(selectedCourse)
        }
        if (selectedDate) {
            setMealSelectedDate(dayjs(selectedDate))
        }

        if (selectedMeal) {
            setMealSelected(selectedMeal)
        }

        // Add event listener on component mount
        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    // Function to fetch search results from the server
    const fetchSearchResults = async (searchTerm) => {
        try {
            const result = await get("/api/meal/search-meal", { name: searchTerm, user_id: currentUser.uid });
            if (result != false) {
                setResults(result);
                setNoResults(false)

            } else {
                setNoResults(true)
            }
        } catch (error) {
            console.error('Error fetching search results:', error);
        }
    };

    const add_meal_handler = async () => {
        try {
            await post("/api/meal-plan/add-meal", {
                user_id: currentUser.uid, meal_id: mealSelected.meal_id,
                course: mealSelectedCourse, meal_date: mealSelectedDate.format('YYYY-MM-DD'),
                replaceUserMealId: replaceUserMealId ? replaceUserMealId : null
            });

            setModalOpen(false)
            window.location.reload();
        } catch (error) {
            console.error('Error adding meal to the user meal_plan', error);
        }
    };

    useEffect(() => {
        if (query) {
            // Add debouncing to reduce API calls
            const timerId = setTimeout(() => {
                fetchSearchResults(query);
            }, 500);  // Adjust debounce delay as needed
            return () => clearTimeout(timerId);  // Cleanup function for useEffect
        } else {
            setResults([])
            setNoResults(false)
        }
    }, [query]);

    function removeAfterDot(str) {
        const dotIndex = str.indexOf('.');
        if (dotIndex === -1) {
            return str; // Return the original string if no dot is found
        }
        return str.slice(0, dotIndex);
    }


    return (



        <FullScreenOverlay modalOpen={modalOpen} setModalOpen={isMobile ? null : setModalOpen}>
            {
                showAddMeal && <CreateMealModal currentUser={currentUser} modalOpen={showAddMeal} setModalOpen={setShowAddMeal} setMealSelected={setMealSelected} />

            }
            {
                showAddSnack && <CreateSnackModal currentUser={currentUser} modalOpen={showAddSnack} setModalOpen={setShowAddSnack} setMealSelected={setMealSelected} />

            }

            {
                showCreateMeal && <div className='add_meal_new_entry_parent'>
                    <p className='black font_family_ovo font_size_24'>
                        Create Entry
                    </p>

                    <div className="explore_meals_add_meal_button cursor_pointer green_gradient gap_12 align_center justify_center"
                        onClick={() => {
                            setShowCreateMeal(false)
                            setShowAddMeal(true)
                        }}
                    >
                        {/* <FaPlus color="white" size={15} /> */}
                        <p className="white font_weight_600">New Meal</p>
                    </div>

                    <div className="explore_meals_add_meal_button cursor_pointer green_gradient gap_12 align_center justify_center"
                        onClick={() => {
                            setShowCreateMeal(false)
                            setShowAddSnack(true)
                        }}
                    >
                        {/* <FaPlus color="white" size={15} /> */}
                        <p className="white font_weight_600">New Snack</p>
                    </div>


                    <hr />
                    <div className='font_family_inter font_size_14 font_weight_600 white explore_meals_filter_apply_button green_orange_gradient'
                        onClick={() => {
                            setShowCreateMeal(false)
                        }}>
                        Cancel
                    </div>
                </div>
            }


            {
                mealSelected == null ? <div className='add_meal_parent_div'>


                    {/* Top Div */}
                    <div className='add_meal_header'>
                        <div style={{ cursor: "pointer" }} onClick={() => setModalOpen(false)}>
                            <IoMdClose color='#235539' size={23} />
                        </div>
                        <div className='green_gradient_p cursor_pointer' onClick={() => { setShowCreateMeal(!showCreateMeal) }} >
                            New Entry
                        </div>
                    </div>

                    {/* Search Box */}
                    <div className='add_meal_search_box_parent'>
                        <input className='add_meal_search_box font_family_inter font_size_14'
                            placeholder="Search..."
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                        />
                    </div>


                    {
                        noResults ? (
                            <p className='gray_scale_1'>No Result Found</p>
                        ) : query === '' ?

                            <MealExplorationSlideBars customMealFunction={setMealSelected} />

                            : (
                                // Meals
                                <div className='add_meal_searched_meals'>
                                    {
                                        results.map((meal) => {
                                            return (
                                                <div key={meal.meal_id} className='add_meal_searched_meal' onClick={() => {
                                                    setMealSelected(meal)
                                                }}>
                                                    <div className='flex gap_20 align_center'>
                                                        <img src={meal.image} alt={meal.name} className='add_meal_meal_image' />

                                                        <p className='flex align_center gap_6 gray_scale_1 font_family_inter font_size_18 font_weight_400'>
                                                            {
                                                                meal.private &&
                                                                <RiGitRepositoryPrivateFill color='#FFCB9E' />
                                                            }
                                                            {meal.name}
                                                        </p>
                                                    </div>
                                                    <p className='gray_scale_1 font_family_inter font_size_16'>
                                                        {removeAfterDot(meal.total_calories)} Calories
                                                    </p>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            )
                    }

                </div >
                    :
                    <div className='add_meal_parent_div'>
                        <div className='add_meal_header'>
                            <div style={{ cursor: "pointer" }} onClick={() => setModalOpen(false)}>
                                <IoMdClose color='#235539' />
                            </div>
                            <div className='green_gradient_p cursor_pointer' onClick={() => {
                                if (replaceUserMealId === null) {
                                    setMealSelectedCourse(null)
                                }
                                setMealSelectedDate(dayjs())
                                setMealSelected(null)
                            }}>
                                Back
                            </div>
                        </div>

                        <div className='add_meal_selected_meal_info'>
                            <div className='flex flex_column gap_20 '>
                                <p className='gray_scale_6 font_family_ovo font_size_30'>{mealSelected.name}</p>
                                <img src={mealSelected.image} className='add_meal_selected_meal_image' />
                            </div>

                            <div className='flex flex_column gap_40'>
                                <FormControl disabled={replaceUserMealId ? true : false}
                                >
                                    <FormLabel>
                                        <p className='gray_scale_1 font_family_inter font_size_18'>
                                            {'Please select the course:'}
                                        </p>
                                    </FormLabel>
                                    <RadioGroup
                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                        name="controlled-radio-buttons-group"

                                        value={mealSelectedCourse}  // Controlled by state
                                        onChange={(e) => {
                                            setMealSelectedCourse(e.target.value)
                                        }}  // Handles the state update on change
                                    >
                                        <FormControlLabel value={'breakfast'} control={
                                            <Radio
                                                sx={{
                                                    color: '#82BD9C',  // When not selected
                                                    '&.Mui-checked': {
                                                        color: '#299257',  // When selected
                                                    },
                                                }}
                                            />
                                        } label={'Breakfast'} sx={{
                                            '.MuiFormControlLabel-label': {
                                                color: '#1F2933', // Change label color here
                                            },
                                        }} />

                                        <FormControlLabel value={'lunch'} control={
                                            <Radio
                                                sx={{
                                                    color: '#82BD9C',  // When not selected
                                                    '&.Mui-checked': {
                                                        color: '#299257',  // When selected
                                                    },
                                                }}
                                            />
                                        } label={'Lunch'} sx={{
                                            '.MuiFormControlLabel-label': {
                                                color: '#1F2933', // Change label color here
                                            },
                                        }} />

                                        <FormControlLabel value={'dinner'} control={

                                            <Radio

                                                sx={{
                                                    color: '#82BD9C',  // When not selected
                                                    '&.Mui-checked': {
                                                        color: '#299257',  // When selected
                                                    },
                                                }}
                                            />
                                        } label={'Dinner'} sx={{
                                            '.MuiFormControlLabel-label': {
                                                color: '#1F2933', // Change label color here
                                            },
                                        }} />

                                        <FormControlLabel value={'snack'} control={

                                            <Radio

                                                sx={{
                                                    color: '#82BD9C',  // When not selected
                                                    '&.Mui-checked': {
                                                        color: '#299257',  // When selected
                                                    },
                                                }}
                                            />
                                        } label={'Snack'} sx={{
                                            '.MuiFormControlLabel-label': {
                                                color: '#1F2933', // Change label color here
                                            },
                                        }} />
                                    </RadioGroup>
                                </FormControl>

                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker label="Meal Date" value={mealSelectedDate}
                                        onChange={(newDate) => {
                                            setMealSelectedDate(newDate)
                                        }}
                                        disabled={replaceUserMealId ? true : false}
                                        disableOpenPicker={true}
                                        views={['year', 'month', 'day']}
                                        renderInput={(params) => (
                                            <TextField
                                                disabled={replaceUserMealId ? true : false}
                                                {...params}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: null, // Hide the calendar icon
                                                }}
                                            />
                                        )}
                                        sx={{
                                            '& .MuiInputLabel-root': {
                                                color: 'gray',
                                                '&.Mui-focused': {
                                                    color: '#1F2933',
                                                },
                                            },
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: '#82BD9C', // Default border color
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: '#299257', // Border color on hover
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#299257', // Border color when focused
                                                },
                                            },
                                        }}

                                    />
                                </LocalizationProvider>
                            </div>
                            <button
                                disabled={!mealSelected || !mealSelectedCourse || !mealSelectedDate}
                                onClick={() => {
                                    add_meal_handler()
                                }} className='large_green_solid_button font_size_14 font_family_inter font_weight_600 green_gradient white center_item' >
                                Submit
                            </button>
                        </div>

                    </div>
            }

        </FullScreenOverlay >

    );

}

export default AddMeal;
